import { ref, type Ref, onMounted, onBeforeUnmount, watch } from 'vue'

export default function useElementSizeAfterDom(targetRef: Ref<HTMLElement | null>) {
  const clientWidth = ref(0)
  const clientHeight = ref(0)

  let observer: ResizeObserver | null = null

  const update = () => {
    const el = targetRef.value
    if (!el) return

    clientWidth.value = el.clientWidth
    clientHeight.value = el.clientHeight
  }

  const observe = (el: HTMLElement) => {
    if (!observer) {
      observer = new ResizeObserver(update)
    }
    observer.observe(el)
    update() // Initial measurement
  }

  const unobserve = (el: HTMLElement) => {
    if (observer) {
      observer.unobserve(el)
    }
  }

  onMounted(() => {
    if (targetRef.value) {
      observe(targetRef.value)
    }
  })

  onBeforeUnmount(() => {
    if (observer) {
      observer.disconnect()
      observer = null
    }
  })

  watch(
    targetRef,
    (newEl, oldEl) => {
      if (oldEl) unobserve(oldEl)
      if (newEl) observe(newEl)
    },
    { flush: 'post' },
  )

  return {
    clientWidth,
    clientHeight,
  }
}
